import { render, staticRenderFns } from "./mproductdetail.vue?vue&type=template&id=78851fa8&scoped=true"
import script from "./mproductdetail.vue?vue&type=script&lang=js"
export * from "./mproductdetail.vue?vue&type=script&lang=js"
import style0 from "./mproductdetail.vue?vue&type=style&index=0&id=78851fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78851fa8",
  null
  
)

export default component.exports